import { CountryDropdownSelect } from 'checkout/components/CountryDropdownSelect'
import { connect, ErrorMessage, Field, getIn } from 'formik'
import React, { FC, FormEvent, ReactNode } from 'react'
import { SVGIcon } from 'shared/components/Icons'
import { colors, fonts } from 'shared/lib'
import { Country } from 'shared/types/Country'
import styled from 'styled-components'

type CountryDropdownProps = {
  availableCountries: Country[]
  disabled?: boolean
  formik?
  name: string
  /** Callback that handles state update when a country is selected. Receives country ISO code. */
  onChange: (countryCode: string) => void
  qaAttr?: string
  title: string | ReactNode
}

const CountryDropdownField: FC<CountryDropdownProps> = ({
  availableCountries,
  disabled,
  formik,
  name,
  onChange,
  qaAttr,
  title,
}) => {
  const hasError = getIn(formik.errors, name) && getIn(formik.touched, name)
  const handleChangeAndBlur = (e: FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value
    formik.setFieldValue(name, value)
    onChange(value)
  }

  return (
    <FieldBox>
      <FormLabel>
        {title}
        <StyledFormikErrorMessage name={name} component="span" data-qa={`${qaAttr}ErrorInLine`} />
      </FormLabel>
      <SelectBox>
        <Field
          onBlur={handleChangeAndBlur}
          onChange={handleChangeAndBlur}
          error={hasError}
          data-qa={qaAttr}
          disabled={disabled}
          autoComplete="country"
          name={name}
          availableCountries={availableCountries}
          component={CountryDropdownSelect}
        />
        <StyledCaret name="caret" color={disabled ? colors.FC2_GREY : colors.FC2_BLACK} />
      </SelectBox>
    </FieldBox>
  )
}

const FieldBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`

const FormLabel = styled.label`
  ${fonts.SUBTITLE_3}
  color: ${colors.FC2_GREY};
  display: flex;
  justify-content: space-between;
`

const StyledCaret = styled(SVGIcon)`
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  right: 15px;
  width: 14px;
  pointer-events: none;
`

const SelectBox = styled.div`
  position: relative;
`

const StyledFormikErrorMessage = styled(ErrorMessage)`
  color: ${colors.FC2_RED};
`

export default connect(CountryDropdownField)
